import { render, staticRenderFns } from "./Internals.vue?vue&type=template&id=6d1d658f&scoped=true&"
import script from "./Internals.vue?vue&type=script&lang=js&"
export * from "./Internals.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-internals.scss?vue&type=style&index=0&id=6d1d658f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d658f",
  null
  
)

export default component.exports